<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>remove_red_eye</v-icon>Ver detalle solicitud
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%;" class="py-0">
            <v-flex xs12>
              <strong class="blue--text">SERVIDOR PÚBLICO: </strong
              >{{ this.form.servidor_publico }}
            </v-flex>
            <v-flex xs12 v-if="l_observaciones.length > 0">
              <span class="blue--text font-weight-bold">OBSERVACIONES:</span>
              <ul>
                <li
                  v-for="observacion in l_observaciones"
                  :key="observacion.id"
                >
                  {{ observacion.observacion }}
                </li>
              </ul>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  class="elevation-1 tabla-comprimida-light"
                  :items="listado_funcionarios"
                  hide-actions
                  :headers="headers"
                >
                  <!-- Cabecera -->
                  <template slot="headerCell" slot-scope="props">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ props.header.text }}
                        </span>
                      </template>
                      <span>
                        {{ props.header.text }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>
                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cerrar
          </v-btn>

          <!-- <v-btn color="primary" @click.prevent="aprobarProgramacion()"
            ><v-icon>done</v-icon>
            Aprobar
          </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      lista_papeleta: [],
      l_observaciones: [],
      gestion: parseInt(this.$util.decodeString(this.$route.params.gestion)),
      headers: [
        {
          text: "Nro papeleta",
          sortable: false,
          align: "center"
        },
        { text: "Estado", sortable: false, align: "center" },
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total dias",
          sortable: false,
          align: "center"
        }
      ],
      form: {}
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerDetalleSolicitudes", async item => {
      this.form = item;
      this.cargarListadoFuncionario();
      this.dialog = true;
      this.l_observaciones = await this.$query.select(
        "estado_vacacion_observacion",
        { id_estado_vacacion: this.form.id_estado_vacacion },
        ["observacion", "id"]
      );
    });
  },

  methods: {
    async cargarListadoFuncionario() {
      try {
        let res = await this.$service.graphql({
          query: `
          query{
            vVacaProgramadas(id_persona:${
              this.form.id_persona
            },restriccion_estados:"9,47",gestion:"${parseInt(this.gestion)}"){
              count
              rows{
                id
                fecha_desde
                fecha_hasta
                id_estado
                fecha_solicitud
                id_unidad
                total_dias
                estado
                secuencia
                id_persona
              }
            }
          }
          `
        });
        this.listado_funcionarios = res.vVacaProgramadas.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogVerDetalleSol");
      this.dialog = false;
    },

    async aprobarProgramacion() {
      let respuesta;
      let resps = [];
      let correcto = true;
      let user = this.$storage.get("user");

      this.loading = true;
      for (let i = 0; i < this.listado_funcionarios.length; i++) {
        const element = this.listado_funcionarios[i];
        try {
          respuesta = await this.$service.graphql({
            query: `
									query{
                    runQuery(consulta:"select vacaciones.fn_aprueba_vacacion_programada_jefe(${element.id},${user.id_persona},${user.id})"){
                      respuesta
                    }
                  }
								`
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_aprueba_vacacion_programada_jefe;
          resps = respuesta.split("|");

          correcto = resps[0];

          if (correcto === "1") {
            this.$message.success("La solicitud fue enviada correctamente");
          } else {
            this.$message.error(resps[1]);
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.loading = false;
      this.close();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/VerDetalleSolicitudes.vue